import { UserWithMyRooms } from "@api/src/types/user";
import { User, Profession } from "@prisma/client";

export const isUserOnboarded = (user: UserWithMyRooms | User | null) => {
  if (!user) return false;
  if (!user.firstName) return false;
  if (!user.lastName) return false;
  if (!user.etablissement) return false;
  if (!user.status_pro) return false;
  if (user.profession === Profession.MEDECIN && !user.specialite) return false;
  return true;
};
